export default {"src":"/_next/static/media/information-love.5ba59fa1.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};